import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function CategoryTab({ location }) {
  const [open, setOopen] = useState(false);
  const [tabName, setTabName] = useState("0");
  const categoryList = [
    { id: "0", link: "/service", name: "이용약관" },
    { id: "1", link: "/policy", name: "개인정보처리방침" },
  ];

  useEffect(() => {
    if (location === "/service") {
      setTabName("0");
    } else if (location === "/policy") {
      setTabName("1");
    }
  }, [location]);

  const tab = () => {
    return (
      <div className="main-tab">
        <Link
          to="/service"
          className={tabName === "0" ? "active" : ""}
          // onClick={() => setCategory(0)}
          onClick={() => setTabName("0")}
        >
          <p>이용약관</p>
        </Link>
        <Link
          to="/policy"
          className={tabName === "1" ? "active" : ""}
          onClick={() => setTabName("1")}
        >
          <p>개인정보처리방침</p>
        </Link>
      </div>
    );
  };

  const tabMobile = () => {
    return (
      <div
        className={`main-tab-mobile ${open ? "focus-color" : "basic-color"}`}
        onClick={() => setOopen(!open)}
      >
        <div className="tab-state">
          <p style={{ fontWeight: open && "normal" }}>
            {tabName === "0" ? "이용약관" : "개인정보처리방침"}
          </p>
          <div
            className={open ? "black-arrow" : "white-arrow"}
            style={{ transform: open && "rotate(0deg)" }}
          />
        </div>
        {open && (
          <div className="tab-list">
            {categoryList.map((item, index) => (
              <Link
                to={item.link}
                onClick={() => {
                  setTabName(item.id);
                }}
                key={index}
                id={item.name}
                style={{ fontWeight: tabName === item.id && "bold" }}
              >
                {item.name}
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  };

  return <>{window.innerWidth > 758 ? tab() : tabMobile()}</>;
}
